import axios from "axios"
import FooterMessage from "components/HorizontalLayout/FooterMessage"
import { ORG_ID, USER_REFERRER_URL } from "helpers/constants"
import externalLinks from "helpers/externalLinks"
import {
  getUserBrowserType,
  getUserIP,
  getUserOS,
} from "helpers/helperFunctions"
import { verifyMobile } from "helpers/requests"
import React, { useEffect, useState } from "react"
import SweetAlert from "react-bootstrap-sweetalert"
import ReCAPTCHA from "react-google-recaptcha"
import PhoneInput from "react-phone-input-2"
import "react-phone-input-2/lib/style.css"
import { Link, useHistory } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap"

const MobileVerification = () => {
  const userDeviceType = getUserOS()
  const userBrowserType = getUserBrowserType()
  const [mobile, setMobile] = useState("")
  const [loading, setLoading] = useState(null)
  const [captchaVerified, setCaptchaVerified] = useState(false)
  const [smsConsent, setSmsConsent] = useState(false)
  const [userIpAddress, setUserIpAddress] = useState(null)
  const [location, setLocation] = useState("")
  const [info, setInfo] = useState({
    confirm: null,
    success_dlg: null,
    error_dlg: null,
    dynamic_title: "",
    dynamic_description: "",
  })

  const history = useHistory()

  function onCaptchaChange(value) {
    console.log("Captcha value:", value)
    setCaptchaVerified(true)
  }

  const getIPAddress = async () => {
    const userIp = await getUserIP()
    setUserIpAddress(userIp)
  }

  useEffect(() => {
    const getLocation = async () => {
      try {
        const response = await axios.get(`https://ipapi.co/ip/`)
        const locationData = await axios.get(
          `https://ipapi.co/${response.data}/json`
        )
        setLocation(locationData.data.country)
      } catch (error) {
        console.error("Error fetching location:", error)
        setLocation("us") // Default to US if location fetch fails
      }
    }
    getLocation()
    getIPAddress()
  }, [])

  const handleVerification = async event => {
    event.preventDefault()

    if (!captchaVerified) {
      setInfo({
        confirm: false,
        error_dlg: true,
        dynamic_title: "Verification Required",
        dynamic_description: "Please complete the captcha verification",
      })
      return
    }

    setLoading(true)
    const data = {
      mobile,
      orgId: ORG_ID,
      sendSms: "true",
      userIpAddress,
      userDeviceType,
      userBrowserType,
      userReferrerUrl: USER_REFERRER_URL,
    }
    const res = await verifyMobile(data)

    if (!res.success) {
      setLoading(null)
      setInfo({
        confirm: false,
        error_dlg: true,
        dynamic_title: "Failed!",
        dynamic_description: res?.message,
      })
    } else {
      localStorage.setItem("vomoz-code", res.data.code)
      localStorage.setItem("vomoz-mobile", mobile)
      setInfo({
        confirm: false,
        success_dlg: true,
        dynamic_title: "Code Sent!",
        dynamic_description: res?.message,
      })
      if (res.data.isExistingCustomer)
        localStorage.setItem("isExistingCustomer", res.data.isExistingCustomer)
      setTimeout(() => {
        history.push("/auth-mobile")
      }, 5000)
    }
  }

  return (
    <React.Fragment>
      {info.success_dlg ? (
        <SweetAlert
          success
          confirmBtnBsStyle="success"
          title={info.dynamic_title}
          onConfirm={() => setInfo({ success_dlg: false })}
        >
          {info.dynamic_description}
        </SweetAlert>
      ) : null}
      {info.error_dlg ? (
        <SweetAlert
          error
          confirmBtnBsStyle="danger"
          title={info.dynamic_title}
          onConfirm={() => setInfo({ error_dlg: false })}
        >
          {info.dynamic_description}
        </SweetAlert>
      ) : null}

      <div className="account-pages my-0 pt-sm-0">
        <Container>
          <Row
            className="justify-content-center"
            style={{
              minHeight: "100vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-soft-primary">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary"> Verification</h5>
                        <p>First we need to validate your number.</p>
                      </div>
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0 mt-5">
                  <div
                    className="p-2"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Form
                      className="form-horizontal"
                      onSubmit={handleVerification}
                      name="mobile-verification-form"
                    >
                      <FormGroup>
                        <Label for="mobile">Enter Mobile Number</Label>
                        <PhoneInput
                          country={location.toLowerCase()}
                          value={mobile}
                          onChange={setMobile}
                          inputProps={{
                            name: "mobile",
                            required: true,
                            autoFocus: true,
                          }}
                          containerStyle={{
                            width: "100%",
                          }}
                          inputStyle={{
                            width: "100%",
                          }}
                        />
                      </FormGroup>

                      <FormGroup>
                        <div style={{ width: "100%" }}>
                          <ReCAPTCHA
                            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                            onChange={onCaptchaChange}
                            style={{ width: "100%" }}
                          />
                        </div>
                      </FormGroup>

                      <FormGroup style={{ marginBottom: 0 }}>
                        <div className="custom-control custom-checkbox">
                          <Input
                            type="checkbox"
                            className="custom-control-input"
                            id="smsConsent"
                            checked={smsConsent}
                            onChange={e => setSmsConsent(e.target.checked)}
                          />
                          <Label
                            className="custom-control-label"
                            htmlFor="smsConsent"
                            style={{
                              fontSize: "0.875rem",
                              lineHeight: 1.6,
                              textAlign: "justify",
                              fontWeight: "normal",
                            }}
                          >
                            I agree to receive transactional SMS messages from
                            VOMOZ LLC regarding my account, including one-time
                            passcodes (OTP), phone verification, authentication
                            alerts, and security notifications. Message
                            frequency varies. Message and data rates may apply.
                            Reply STOP to opt out or HELP for assistance. By
                            opting in, I confirm that I am the authorized user
                            of this mobile number.
                          </Label>
                        </div>
                      </FormGroup>

                      <FormGroup style={{ marginTop: "0.25rem" }}>
                        <p
                          className="text-muted"
                          style={{
                            fontSize: "0.875rem",
                            textAlign: "left",
                            marginBottom: "1rem",
                          }}
                        >
                          Read our{" "}
                          <a
                            href={
                              externalLinks.vomozGroupLandingPageSMSPrivacyPolicy
                            }
                            className="text-primary"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            SMS Terms & Privacy Policy
                          </a>{" "}
                          for full details.
                        </p>
                      </FormGroup>

                      <FormGroup>
                        <button
                          className="btn btn-primary w-100 waves-effect waves-light"
                          type="submit"
                          disabled={!captchaVerified || !mobile}
                        >
                          {loading ? "Sending..." : "Send PIN"}
                        </button>
                      </FormGroup>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-4 text-center">
                <p>
                  Already Verified?{" "}
                  <Link to="/login" className="font-weight-medium text-primary">
                    {" "}
                    Login here
                  </Link>{" "}
                </p>
                <FooterMessage />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default MobileVerification
